import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import { AppThemeProvider } from './hooks/theme';

ReactDOM.render(
  <AppThemeProvider>
    <App />
  </AppThemeProvider>,
  document.getElementById('root'),
);
